import { combineReducers } from 'redux';
import user from './user';
import header from './header';
import open_menu from './open_menu';
import sidebar from './sidebar';
import access_token from './access-token';
import referral_code from './referral_code';

export const reducer = combineReducers({
    user,
    header,
    open_menu,
    sidebar,
    access_token,
    referral_code
});

export type RootState = ReturnType<typeof reducer>;

export default reducer;